import React, { } from "react";
import { IAppTableColumnProps } from "./AppTableColumn";
import {AppTableContext} from "./AppTable"
import {AppTableRow} from "./AppTableItem";

export interface IProps {
	rowKey?: string;
	columns?: IAppTableColumnProps[];
	width?:number;
	reLoadLayout?:()=>void
}


export class AppTableBody extends React.Component<IProps> {
	
	componentDidMount ()  {
		this.props.reLoadLayout && this.props.reLoadLayout()
	}

	renderColGroup = () => {
		let { columns } = this.props
		return (
			<colgroup>
				{columns.map((column: IAppTableColumnProps, index) => {
					return (column.width || column.width!==0) ?
						<col key={`${index}_col`} width={`${column.width}px`} /> : <col key={`${index}_col`} />
				})}
			</colgroup>
		);
	}

	renderTable = (context:AppTableContext) =>{
		let {width } = this.props; 
		let {data} = context;
		let currentwidth
		if(width===-1){
			currentwidth='100%';
		}else{
			currentwidth=width+'px';
		}

		let { columns, rowKey } = this.props; 
		rowKey = rowKey || 'id';

		return (
		<table cellPadding="0" cellSpacing="0" style={{ width:currentwidth  }} onMouseOut={()=>context.rowHover(null)}  >
			{this.renderColGroup()}
			<tbody>
				{data.map((d: any, index)=>{
					return <AppTableRow key={`_apptable_row_${index}`} rowKey={rowKey} columns={columns} data={d} dataIndex={index}/>
				})}
			</tbody>
		</table>);
	}


	render() {
		return (<AppTableContext.Consumer>{this.renderTable}</AppTableContext.Consumer>);

	}
}






// WEBPACK FOOTER //
// ./src/components/AppTable/AppTableBody.tsx